import { FormField, QuestionnaireDescription, useError } from "common";
import { useField } from "formik";
import { noop, omit } from "lodash";
import React from "react";
import { FormatInput } from "../Input/FormatInput";
import { FieldProps } from "./TextField";

export const UnitField = ({ name, field, isRequired, classNames, showDescription = true, onChange }: FieldProps) => {
    const [props, , helpers] = useField(name);
    const error = useError(name);
    const rest = omit(props, "onChange");

    return (
        <FormField label={field.label} name={name} classNames={{ label: classNames?.label }}>
            {showDescription && <QuestionnaireDescription field={field} />}
            <FormatInput
                {...rest}
                isRequired={isRequired}
                isError={!!error}
                suffix={` ${field.unit}`}
                onValueChange={({ floatValue }) => {
                    helpers.setValue(floatValue?.toString() ?? "");
                    onChange ? onChange(floatValue?.toString() ?? "") : noop();
                }}
            />
        </FormField>
    );
};
